import type { LocalePack } from "./types";

const perks = [
  { title: "Geen borg", text: "Reserveer zonder aanbetaling en zonder creditcard nodig." },
  { title: "Gratis ophalen", text: "Gratis ophalen op ons kantoor in Boekarest of op Otopeni Airport." },
  { title: "Alles inbegrepen", text: "RCA+CASCO-verzekering, rovinieta en onbeperkte kilometers zitten in de prijs." },
  { title: "24/7 overdracht", text: "Dag en nacht bereikbaar, ook via WhatsApp op +40738792499." },
];

const airportPerks = [
  { title: "Ophalen op Otopeni", text: "Gratis ophalen direct bij aankomst op Henri Coandă Airport (OTP)." },
  { title: "Geen wachttijd", text: "Uw auto staat klaar zodra u landt, dankzij 24/7 overdracht." },
  { title: "Vaste prijs vanaf 35 EUR/dag", text: "Transparante tarieven, geen verborgen kosten bij de balie." },
  { title: "Contact via WhatsApp", text: "Stuur uw vluchtnummer naar +40738792499 voor een vlotte ontvangst." },
];

const rulesPerks = [
  { title: "Rovinieta inbegrepen", text: "U hoeft zelf geen wegenvignet te kopen, wij regelen dit voor u." },
  { title: "Lokale kennis", text: "Wij informeren u over de actuele verkeersregels in Roemenië." },
  { title: "Geen verrassingen", text: "Alle verplichte documenten zitten al in de auto bij vertrek." },
  { title: "Hulp onderweg", text: "Bij vragen over regelgeving staat ons team via WhatsApp klaar." },
];

const guidePerks = [
  { title: "Auto's geschikt voor bergwegen", text: "Betrouwbare wagens voor de Transfăgărășan en de Karpaten." },
  { title: "Onbeperkte kilometers", text: "Rijd zo ver u wilt door Transsylvanië zonder bijkomende kosten." },
  { title: "Volledige verzekering", text: "RCA+CASCO geeft u gemoedsrust op elke route, hoe bochtig ook." },
  { title: "Flexibele levering", text: "Op aanvraag leveren wij de auto ook buiten Boekarest via WhatsApp." },
];

export const nl: LocalePack = {
  code: "nl",
  htmlLang: "nl",
  dir: "ltr",
  ui: {
    label: "Nederlands",
    nav: {
      country: "Roemenië",
      airports: "Luchthavens",
      cities: "Steden",
      guides: "Reisgidsen",
    },
    bookCta: "Nu boeken",
    fleetCta: "Bekijk ons wagenpark",
    whatsappCta: "Chat op WhatsApp",
    fleetTitle: "Ons wagenpark",
    fleetSubtitle: "28 goed onderhouden auto's, van compact tot 7-zits, klaar voor uw reis.",
    faqTitle: "Veelgestelde vragen",
    mapTitle: "Waar u ons vindt",
    relatedTitle: "Ook interessant",
    priceNote: "Prijzen vanaf 35 EUR/dag, inclusief verzekering, rovinieta en onbeperkte kilometers.",
    breadcrumbHome: "Home",
  },
  pages: {
    country: {
      slug: "",
      title: "Autohuur Roemenië | Vanaf 35 EUR/dag – carentals.ro",
      description: "Autohuur Roemenië zonder borg, met gratis ophalen in Boekarest of Otopeni. Verzekering en rovinieta inbegrepen. Boek via WhatsApp.",
      eyebrow: "Autoverhuur in heel Roemenië",
      h1: "Autohuur Roemenië: eenvoudig, transparant, zonder borg",
      intro: "Bij carentals.ro huurt u een auto in Roemenië zonder gedoe: geen borg, geen creditcard verplicht, en gratis ophalen in Boekarest of op Otopeni Airport. Ons wagenpark van 28 auto's staat 24/7 klaar voor uw reis door het land.",
      perks,
      sections: [
        {
          h2: "Waarom autohuur Roemenië via carentals.ro",
          body: [
            "Wij zijn een lokaal verhuurbedrijf gevestigd op Bulevardul Regina Elisabeta 33 in Boekarest, met jarenlange ervaring in autoverhuur voor toeristen en zakenreizigers. Onze prijzen beginnen vanaf 35 EUR per dag, inclusief RCA+CASCO-verzekering en onbeperkte kilometers.",
            "U kunt betalen met bankpas, contant in EUR of RON, of via bankoverschrijving. Een borg of creditcard is niet nodig, wat het huren van een auto in Roemenië veel toegankelijker maakt dan bij veel grote verhuurders.",
          ],
        },
        {
          h2: "Ophalen en afleveren in heel het land",
          body: [
            "Ophalen is gratis op ons kantoor in Boekarest en op Henri Coandă Airport (Otopeni, OTP). Wilt u de auto elders in Boekarest laten bezorgen, dan rekenen wij een vaste vergoeding van 20 EUR.",
            "Voor levering buiten Boekarest, zoals Brasov, Cluj of Constanța, regelen wij dit op aanvraag met een offerte op maat. Neem hiervoor contact op via WhatsApp op +40738792499.",
          ],
        },
        {
          h2: "Reizen door Roemenië met vertrouwen",
          body: [
            "Van de bergpassen van Transsylvanië tot de kust van de Zwarte Zee: onze auto's zijn uitgerust voor elk type reis. Alle voertuigen worden regelmatig onderhouden en gecontroleerd voor vertrek.",
            "Dankzij de 24/7 overdracht kunt u op elk moment van de dag of nacht vertrekken of terugkeren, ideaal voor vluchten met late aankomst of vroeg vertrek.",
          ],
        },
      ],
      faqs: [
        { q: "Heb ik een borg nodig om een auto te huren in Roemenië?", a: "Nee, bij carentals.ro huurt u zonder borg en zonder verplichte creditcard. Betaling kan met bankpas, contant of overschrijving." },
        { q: "Wat kost autohuur in Roemenië gemiddeld?", a: "Onze tarieven starten vanaf 35 EUR per dag, inclusief verzekering, rovinieta en onbeperkte kilometers." },
        { q: "Kan ik de auto gratis ophalen op de luchthaven?", a: "Ja, ophalen op Henri Coandă Airport (Otopeni) en op ons kantoor in Boekarest is altijd gratis." },
        { q: "Is de rovinieta (wegenvignet) inbegrepen?", a: "Ja, de rovinieta zit standaard bij de huurprijs inbegrepen, u hoeft niets extra te regelen." },
      ],
      keywords: "autohuur roemenie, auto huren roemenie, autoverhuur roemenie, carentals.ro",
    },
    "airport-otopeni": {
      slug: "autohuur-otopeni",
      title: "Autohuur Otopeni Airport | Gratis ophalen – carentals.ro",
      description: "Autohuur Otopeni (OTP): gratis ophalen bij aankomst, geen borg, verzekering inbegrepen. Reserveer nu vanaf 35 EUR/dag via carentals.ro.",
      eyebrow: "Autoverhuur op Henri Coandă Airport",
      h1: "Autohuur Otopeni: uw auto klaar bij aankomst op OTP",
      intro: "Land op Henri Coandă Airport en stap direct in uw huurauto. Autohuur Otopeni bij carentals.ro betekent gratis ophalen, geen borg en volledige verzekering, 24 uur per dag beschikbaar.",
      perks: airportPerks,
      sections: [
        {
          h2: "Gratis ophalen op Otopeni Airport",
          body: [
            "Zodra u door de douane bent, brengen wij u snel naar uw auto. Er zijn geen extra kosten voor ophalen op de luchthaven, in tegenstelling tot veel andere verhuurders die luchthaventoeslagen rekenen.",
            "Stuur ons vooraf uw vluchtnummer via WhatsApp op +40738792499, zodat wij precies weten wanneer u aankomt, ook bij vertraging.",
          ],
        },
        {
          h2: "Geen borg, geen stress",
          body: [
            "Wij vragen geen borg en geen creditcard bij het ophalen van uw auto op Otopeni. U betaalt eenvoudig met bankpas, contant in EUR of RON, of per overschrijving.",
            "Zo kunt u meteen doorrijden naar Boekarest, de kust of de Karpaten zonder ingewikkelde formaliteiten aan de balie.",
          ],
        },
        {
          h2: "Alles inbegrepen bij uw huurauto",
          body: [
            "Elke huurauto op Otopeni Airport wordt geleverd met RCA+CASCO-verzekering, rovinieta en onbeperkte kilometers. Zo weet u vooraf precies wat u betaalt, vanaf 35 EUR per dag.",
            "Onze 28 auto's variëren van compacte modellen tot ruime 7-zitters, geschikt voor elke reis vanaf de luchthaven.",
          ],
        },
      ],
      faqs: [
        { q: "Waar haal ik de huurauto op bij Otopeni Airport?", a: "Wij komen u ophalen bij de aankomsthal van Henri Coandă Airport, gratis en zonder wachttijd." },
        { q: "Moet ik betalen voor ophalen op de luchthaven?", a: "Nee, ophalen op Otopeni Airport is volledig gratis bij carentals.ro." },
        { q: "Wat als mijn vlucht vertraging heeft?", a: "Geen probleem, stuur ons uw vluchtnummer via WhatsApp en wij passen de ophaaltijd automatisch aan." },
        { q: "Is er een minimum huurperiode op Otopeni?", a: "Nee, u kunt huren voor zo kort of lang als u wilt, met tarieven vanaf 35 EUR per dag." },
      ],
      keywords: "autohuur otopeni, auto huren otopeni airport, autoverhuur otp, boekarest airport auto huren",
    },
    "airport-cluj": {
      slug: "autohuur-cluj-airport",
      title: "Autohuur Cluj Airport (CLJ) – carentals.ro",
      description: "Autohuur op Cluj Airport: levering op aanvraag vanuit Boekarest, geen borg, verzekering inbegrepen. Vraag een offerte via WhatsApp.",
      eyebrow: "Autoverhuur bij Cluj-Napoca",
      h1: "Autohuur Cluj Airport: flexibele levering vanuit Boekarest",
      intro: "Vliegt u aan op Cluj Airport (CLJ)? Carentals.ro levert uw huurauto op aanvraag vanuit Boekarest, met dezelfde voorwaarden: geen borg, volledige verzekering en onbeperkte kilometers.",
      perks: airportPerks,
      sections: [
        {
          h2: "Autoverhuur voor Transsylvanië",
          body: [
            "Cluj-Napoca is de perfecte uitvalsbasis om Transsylvanië te verkennen. Onze auto's zijn geschikt voor zowel stadsritten als langere tochten door de heuvels rondom Cluj.",
            "Omdat ons hoofdkantoor in Boekarest zit, regelen wij levering naar Cluj Airport op aanvraag, met een duidelijke offerte vooraf.",
          ],
        },
        {
          h2: "Eerlijk en transparant over afstand",
          body: [
            "We zijn open over de afstand: Cluj ligt op meerdere uren rijden van Boekarest, dus levering en one-way ritten worden per geval bekeken en geprijsd.",
            "Neem contact op via WhatsApp op +40738792499 om de mogelijkheden en kosten voor uw specifieke datum te bespreken.",
          ],
        },
        {
          h2: "Dezelfde voorwaarden, waar u ook bent",
          body: [
            "Ook bij levering in Cluj geniet u van RCA+CASCO-verzekering, rovinieta en onbeperkte kilometers, net als bij ophalen in Boekarest.",
            "Betalen kan met bankpas, contant in EUR of RON, of via overschrijving, zonder borg of creditcard vereist.",
          ],
        },
      ],
      faqs: [
        { q: "Kan ik een auto huren direct op Cluj Airport?", a: "Ja, wij leveren op aanvraag vanuit Boekarest naar Cluj Airport, met een offerte op maat." },
        { q: "Wat kost levering naar Cluj?", a: "De kosten hangen af van de afstand en datum. Vraag een gratis offerte via WhatsApp op +40738792499." },
        { q: "Is een one-way huur mogelijk vanaf Cluj?", a: "Ja, one-way verhuur is mogelijk in overleg, neem contact op om de opties te bespreken." },
        { q: "Zijn verzekering en rovinieta ook inbegrepen bij levering in Cluj?", a: "Ja, alle huurauto's, ongeacht leveringslocatie, bevatten RCA+CASCO en rovinieta." },
      ],
      keywords: "autohuur cluj airport, auto huren cluj napoca, autoverhuur cluj",
    },
    "airport-iasi": {
      slug: "autohuur-iasi-airport",
      title: "Autohuur Iași Airport (IAS) – carentals.ro",
      description: "Autohuur Iași Airport: levering op aanvraag vanuit Boekarest, geen borg, RCA+CASCO en rovinieta inbegrepen. Offerte via WhatsApp.",
      eyebrow: "Autoverhuur in Moldavië, Roemenië",
      h1: "Autohuur Iași Airport: uw auto na een korte regeling",
      intro: "Voor autohuur op Iași Airport (IAS) regelt carentals.ro levering op aanvraag vanuit Boekarest. U profiteert van dezelfde voordelen: geen borg, volledige verzekering en onbeperkte kilometers.",
      perks: airportPerks,
      sections: [
        {
          h2: "Autohuur in het oosten van Roemenië",
          body: [
            "Iași is een prachtige uitvalsbasis om de regio Moldavië te ontdekken, van kloosters tot historische centra. Wij zorgen dat u hier met een betrouwbare auto kunt reizen.",
            "Aangezien Iași ver van Boekarest ligt, wordt levering per aanvraag geregeld met een duidelijke prijsopgave vooraf.",
          ],
        },
        {
          h2: "Snel en duidelijk contact",
          body: [
            "Stuur uw reisdata en vluchtnummer via WhatsApp naar +40738792499, en wij bevestigen binnen korte tijd of en tegen welke kosten levering naar Iași mogelijk is.",
            "Zo weet u vooraf precies waar u aan toe bent, zonder verrassingen bij aankomst.",
          ],
        },
        {
          h2: "Volledige service, ook op afstand",
          body: [
            "Elke auto die naar Iași wordt geleverd, bevat RCA+CASCO-verzekering, rovinieta en onbeperkte kilometers, exact zoals bij ophalen in Boekarest.",
            "Betaling gebeurt zonder borg, via bankpas, contant of overschrijving, in EUR of RON.",
          ],
        },
      ],
      faqs: [
        { q: "Levert carentals.ro auto's naar Iași Airport?", a: "Ja, op aanvraag vanuit Boekarest, met een offerte op maat voor uw datum." },
        { q: "Is er een borg nodig bij ophalen in Iași?", a: "Nee, ook bij levering in Iași is geen borg of creditcard vereist." },
        { q: "Hoe vraag ik een offerte aan voor Iași?", a: "Stuur uw gegevens via WhatsApp naar +40738792499, wij reageren snel met een prijsopgave." },
        { q: "Zit de verzekering ook inbegrepen bij levering buiten Boekarest?", a: "Ja, RCA+CASCO en rovinieta zijn altijd inbegrepen, ongeacht de leveringslocatie." },
      ],
      keywords: "autohuur iasi airport, auto huren iasi, autoverhuur moldavie roemenie",
    },
    "airport-timisoara": {
      slug: "autohuur-timisoara-airport",
      title: "Autohuur Timișoara Airport (TSR) – carentals.ro",
      description: "Autohuur Timișoara Airport: levering op aanvraag, geen borg, verzekering en rovinieta inbegrepen. Vraag een offerte via WhatsApp.",
      eyebrow: "Autoverhuur in West-Roemenië",
      h1: "Autohuur Timișoara Airport: uw huurauto op maat geregeld",
      intro: "Wilt u een auto huren op Timișoara Airport (TSR)? Carentals.ro regelt levering op aanvraag vanuit Boekarest, met dezelfde betrouwbare voorwaarden zonder borg.",
      perks: airportPerks,
      sections: [
        {
          h2: "Reizen door het westen van Roemenië",
          body: [
            "Timișoara is een bruisende stad dicht bij de grens met Hongarije en Servië, ideaal als startpunt voor een rondreis. Onze auto's zijn geschikt voor zowel stad als lange afstanden.",
            "Omdat Timișoara ver van ons kantoor in Boekarest ligt, bespreken wij levering en prijs altijd vooraf per aanvraag.",
          ],
        },
        {
          h2: "Eenvoudig een offerte aanvragen",
          body: [
            "Neem contact op via WhatsApp op +40738792499 met uw vluchtgegevens en gewenste huurperiode. Wij sturen u snel een duidelijke prijsopgave voor levering naar Timișoara.",
            "Ook one-way verhuur vanaf Timișoara behoort tot de mogelijkheden, in overleg met ons team.",
          ],
        },
        {
          h2: "Zelfde kwaliteit, verder van Boekarest",
          body: [
            "Elke auto geleverd in Timișoara bevat RCA+CASCO-verzekering, rovinieta en onbeperkte kilometers, net als op ons hoofdkantoor.",
            "Betaal zonder borg, met bankpas, contant of overschrijving, in EUR of RON, precies zoals u gewend bent.",
          ],
        },
      ],
      faqs: [
        { q: "Kan ik een auto huren op Timișoara Airport?", a: "Ja, via levering op aanvraag vanuit Boekarest, met een offerte op maat." },
        { q: "Hoeveel kost levering naar Timișoara?", a: "Dit hangt af van afstand en datum, vraag een gratis offerte via WhatsApp." },
        { q: "Is one-way verhuur mogelijk vanaf Timișoara?", a: "Ja, dit kan in overleg geregeld worden met ons team." },
        { q: "Heb ik een creditcard nodig bij levering in Timișoara?", a: "Nee, een creditcard of borg is nooit verplicht bij carentals.ro." },
      ],
      keywords: "autohuur timisoara airport, auto huren timisoara, autoverhuur west roemenie",
    },
    "airport-sibiu": {
      slug: "autohuur-sibiu-airport",
      title: "Autohuur Sibiu Airport (SBZ) – carentals.ro",
      description: "Autohuur Sibiu Airport: levering op aanvraag vanuit Boekarest, geen borg, volledige verzekering. Offerte via WhatsApp +40738792499.",
      eyebrow: "Autoverhuur bij de Karpaten",
      h1: "Autohuur Sibiu Airport: ideaal startpunt voor de Transfăgărășan",
      intro: "Sibiu Airport (SBZ) ligt dicht bij de mooiste bergroutes van Roemenië. Carentals.ro levert uw huurauto op aanvraag vanuit Boekarest, zonder borg en met volledige verzekering.",
      perks: airportPerks,
      sections: [
        {
          h2: "De poort naar Transsylvanië",
          body: [
            "Sibiu is een prachtige historische stad en het perfecte vertrekpunt voor een tocht over de Transfăgărășan of door de Karpaten. Onze auto's zijn hierop voorbereid.",
            "Levering naar Sibiu Airport wordt op aanvraag geregeld vanuit ons kantoor in Boekarest, met een heldere prijsopgave.",
          ],
        },
        {
          h2: "Snel geregeld via WhatsApp",
          body: [
            "Stuur uw vluchtnummer en reisdata naar +40738792499 en wij bevestigen snel de mogelijkheden en kosten voor levering in Sibiu.",
            "Zo kunt u meteen na aankomst vertrekken richting de bergen, zonder tijd te verliezen.",
          ],
        },
        {
          h2: "Volledige service in Sibiu",
          body: [
            "Ook in Sibiu bevat elke huurauto RCA+CASCO-verzekering, rovinieta en onbeperkte kilometers, precies zoals in Boekarest.",
            "Betaling gebeurt zonder borg of creditcard, via bankpas, contant in EUR of RON, of overschrijving.",
          ],
        },
      ],
      faqs: [
        { q: "Levert carentals.ro auto's naar Sibiu Airport?", a: "Ja, op aanvraag vanuit Boekarest, met een duidelijke offerte vooraf." },
        { q: "Is Sibiu een goed startpunt voor de Transfăgărășan?", a: "Zeker, Sibiu ligt vlak bij deze beroemde bergroute en is een ideaal vertrekpunt." },
        { q: "Wat kost levering naar Sibiu Airport?", a: "De prijs hangt af van afstand en datum, vraag een gratis offerte via WhatsApp." },
        { q: "Is de verzekering ook geldig in de bergen?", a: "Ja, RCA+CASCO dekt uw volledige reis door heel Roemenië, inclusief bergroutes." },
      ],
      keywords: "autohuur sibiu airport, auto huren sibiu, transfagarasan auto huren",
    },
    "city-bucharest": {
      slug: "autohuur-boekarest",
      title: "Autohuur Boekarest | Vanaf 35 EUR/dag – carentals.ro",
      description: "Autohuur Boekarest zonder borg. Gratis ophalen op kantoor of Otopeni Airport, verzekering inbegrepen. Boek nu via carentals.ro.",
      eyebrow: "Autoverhuur in de hoofdstad",
      h1: "Autohuur Boekarest: gemakkelijk en zonder borg",
      intro: "Ons kantoor bevindt zich op Bulevardul Regina Elisabeta 33, in het hart van Boekarest. Huur hier een auto zonder borg, met gratis ophalen op kantoor of op Otopeni Airport.",
      perks,
      sections: [
        {
          h2: "Centraal gelegen kantoor",
          body: [
            "Ons kantoor aan Bulevardul Regina Elisabeta 33 is eenvoudig te bereiken vanuit het centrum van Boekarest. U kunt hier gratis uw huurauto ophalen en inleveren.",
            "Wilt u de auto elders in de stad laten bezorgen? Dat kan voor een vaste vergoeding van 20 EUR, handig als u in een hotel buiten het centrum verblijft.",
          ],
        },
        {
          h2: "Verkennen van Boekarest en omgeving",
          body: [
            "Met een huurauto ontdekt u eenvoudig het Parlementsgebouw, de oude binnenstad en dagtrips naar bijvoorbeeld Snagov of Ploiești. Onbeperkte kilometers geven u volledige vrijheid.",
            "Ons wagenpark van 28 auto's biedt voor elke reiziger iets passends, van compacte stadsauto's tot ruime 7-zitters voor gezinnen.",
          ],
        },
        {
          h2: "Betrouwbaar en flexibel huren",
          body: [
            "Betaal zonder borg via bankpas, contant in EUR of RON, of per overschrijving. Onze auto's bevatten standaard RCA+CASCO-verzekering en rovinieta.",
            "Dankzij 24/7 overdracht kunt u de auto ophalen en inleveren op het moment dat u het beste uitkomt, dag of nacht.",
          ],
        },
      ],
      faqs: [
        { q: "Waar kan ik een auto huren in Boekarest?", a: "Op ons kantoor aan Bulevardul Regina Elisabeta 33 of op Otopeni Airport, beide gratis." },
        { q: "Kost bezorging in Boekarest extra?", a: "Ja, bezorging op een ander adres in Boekarest kost een vaste 20 EUR." },
        { q: "Is er een borg nodig in Boekarest?", a: "Nee, wij vragen geen borg en geen creditcard bij het huren van een auto." },
        { q: "Kan ik 's nachts een auto ophalen in Boekarest?", a: "Ja, wij bieden 24/7 overdracht aan, ook 's nachts." },
      ],
      keywords: "autohuur boekarest, auto huren boekarest, autoverhuur bucharest",
    },
    "city-brasov": {
      slug: "autohuur-brasov",
      title: "Autohuur Brasov | Levering vanuit Boekarest – carentals.ro",
      description: "Autohuur Brasov: levering vanuit Boekarest op aanvraag, geen borg, volledige verzekering. Vraag een offerte via WhatsApp.",
      eyebrow: "Autoverhuur bij de Karpaten",
      h1: "Autohuur Brasov: uw uitvalsbasis voor de Karpaten",
      intro: "Brasov is een van de mooiste steden van Roemenië, omringd door bergen. Carentals.ro levert uw huurauto op aanvraag vanuit Boekarest, zonder borg en met volledige verzekering.",
      perks,
      sections: [
        {
          h2: "Ontdek Brasov en de Karpaten",
          body: [
            "Vanuit Brasov bereikt u eenvoudig kastelen zoals Bran en Peleș, en bergdorpen in de omgeving. Een huurauto geeft u de vrijheid om in uw eigen tempo te reizen.",
            "Onze auto's zijn geschikt voor zowel de bergwegen rond Brasov als voor langere ritten door heel Transsylvanië.",
          ],
        },
        {
          h2: "Levering op aanvraag",
          body: [
            "Omdat Brasov op enige afstand van Boekarest ligt, regelen wij levering op aanvraag met een duidelijke offerte vooraf. Neem contact op via WhatsApp op +40738792499.",
            "Ook inter-stedelijke of one-way verhuur vanaf Brasov is mogelijk in overleg met ons team.",
          ],
        },
        {
          h2: "Dezelfde voorwaarden als in Boekarest",
          body: [
            "Elke auto geleverd in Brasov bevat RCA+CASCO-verzekering, rovinieta en onbeperkte kilometers, zonder verborgen kosten.",
            "Betaal zonder borg, via bankpas, contant of overschrijving, in EUR of RON.",
          ],
        },
      ],
      faqs: [
        { q: "Kan ik een auto laten leveren in Brasov?", a: "Ja, op aanvraag vanuit Boekarest, met een offerte op maat." },
        { q: "Wat kost levering naar Brasov?", a: "Dit hangt af van de afstand en datum, vraag een gratis offerte via WhatsApp." },
        { q: "Is Brasov een goede basis voor kastelen bezoeken?", a: "Zeker, Bran en Peleș liggen op korte afstand van Brasov." },
        { q: "Is verzekering inbegrepen bij levering in Brasov?", a: "Ja, RCA+CASCO en rovinieta zijn altijd inbegrepen." },
      ],
      keywords: "autohuur brasov, auto huren brasov, autoverhuur karpaten",
    },
    "city-cluj": {
      slug: "autohuur-cluj-napoca",
      title: "Autohuur Cluj-Napoca | carentals.ro",
      description: "Autohuur Cluj-Napoca: levering op aanvraag vanuit Boekarest, geen borg, verzekering inbegrepen. Offerte via WhatsApp.",
      eyebrow: "Autoverhuur in Transsylvanië",
      h1: "Autohuur Cluj-Napoca: flexibel en zonder borg",
      intro: "Cluj-Napoca is het bruisende hart van Transsylvanië. Carentals.ro regelt levering van uw huurauto op aanvraag vanuit Boekarest, zonder borg en met volledige verzekering.",
      perks,
      sections: [
        {
          h2: "Studentenstad met veel te ontdekken",
          body: [
            "Cluj-Napoca combineert historische architectuur met een levendige studentencultuur. Met een huurauto verkent u eenvoudig ook de omliggende heuvels en dorpjes.",
            "Onze auto's zijn geschikt voor stadsgebruik én voor langere tochten door Transsylvanië.",
          ],
        },
        {
          h2: "Levering vanuit Boekarest",
          body: [
            "Aangezien Cluj-Napoca op afstand van ons kantoor ligt, wordt levering per aanvraag geregeld met een transparante prijsopgave. Neem contact op via WhatsApp op +40738792499.",
            "One-way verhuur vanaf Cluj-Napoca behoort eveneens tot de mogelijkheden.",
          ],
        },
        {
          h2: "Volledig verzekerd onderweg",
          body: [
            "Elke auto geleverd in Cluj-Napoca bevat RCA+CASCO-verzekering, rovinieta en onbeperkte kilometers.",
            "U betaalt zonder borg, met bankpas, contant in EUR of RON, of via overschrijving.",
          ],
        },
      ],
      faqs: [
        { q: "Kan ik een auto huren in Cluj-Napoca?", a: "Ja, via levering op aanvraag vanuit Boekarest, met een offerte op maat." },
        { q: "Wat kost levering naar Cluj-Napoca?", a: "De prijs hangt af van de afstand en datum, vraag een gratis offerte via WhatsApp." },
        { q: "Is one-way huur mogelijk vanuit Cluj-Napoca?", a: "Ja, dit kan in overleg met ons team geregeld worden." },
        { q: "Is de rovinieta inbegrepen bij levering in Cluj?", a: "Ja, de rovinieta zit altijd bij de huurprijs inbegrepen." },
      ],
      keywords: "autohuur cluj napoca, auto huren cluj, autoverhuur transsylvanie",
    },
    "city-constanta": {
      slug: "autohuur-constanta",
      title: "Autohuur Constanța | Zwarte Zee – carentals.ro",
      description: "Autohuur Constanța: levering op aanvraag vanuit Boekarest, geen borg, verzekering inbegrepen. Offerte via WhatsApp +40738792499.",
      eyebrow: "Autoverhuur aan de Zwarte Zee",
      h1: "Autohuur Constanța: op weg naar de Zwarte Zee",
      intro: "Constanța en de kust van de Zwarte Zee zijn ideaal te verkennen met een huurauto. Carentals.ro regelt levering op aanvraag vanuit Boekarest, zonder borg.",
      perks,
      sections: [
        {
          h2: "De kust op eigen tempo verkennen",
          body: [
            "Met een auto ontdekt u eenvoudig de badplaatsen langs de Zwarte Zee, van Mamaia tot Vama Veche. Onbeperkte kilometers geven u alle vrijheid.",
            "Onze auto's zijn comfortabel voor lange ritten, ideaal voor een dagje strand of een langere kustvakantie.",
          ],
        },
        {
          h2: "Levering naar Constanța",
          body: [
            "Omdat Constanța ver van Boekarest ligt, regelen wij levering op aanvraag met een duidelijke offerte vooraf. Neem contact op via WhatsApp op +40738792499.",
            "One-way verhuur vanaf Constanța is eveneens mogelijk, in overleg met ons team.",
          ],
        },
        {
          h2: "Zorgeloos genieten van de kust",
          body: [
            "Elke auto geleverd in Constanța bevat RCA+CASCO-verzekering, rovinieta en onbeperkte kilometers.",
            "Betaal zonder borg, via bankpas, contant in EUR of RON, of overschrijving.",
          ],
        },
      ],
      faqs: [
        { q: "Kan ik een auto laten leveren in Constanța?", a: "Ja, op aanvraag vanuit Boekarest, met een offerte op maat." },
        { q: "Wat kost levering naar de kust?", a: "Dit hangt af van de afstand en datum, vraag een gratis offerte via WhatsApp." },
        { q: "Is een one-way huur mogelijk vanuit Constanța?", a: "Ja, dit kan in overleg met ons team geregeld worden." },
        { q: "Is verzekering inbegrepen tijdens de kustreis?", a: "Ja, RCA+CASCO dekt uw volledige reis, inclusief de kustroute." },
      ],
      keywords: "autohuur constanta, auto huren zwarte zee, autoverhuur mamaia",
    },
    cheap: {
      slug: "goedkope-autohuur-roemenie",
      title: "Goedkope Autohuur Roemenië | Vanaf 35 EUR – carentals.ro",
      description: "Goedkope autohuur in Roemenië vanaf 35 EUR/dag, zonder borg. Verzekering, rovinieta en onbeperkte kilometers inbegrepen.",
      eyebrow: "Voordelig autohuur",
      h1: "Goedkope autohuur in Roemenië, zonder verborgen kosten",
      intro: "Op zoek naar goedkope autohuur in Roemenië? Bij carentals.ro huurt u al vanaf 35 EUR per dag, inclusief verzekering, rovinieta en onbeperkte kilometers, zonder borg.",
      perks,
      sections: [
        {
          h2: "Transparante, lage prijzen",
          body: [
            "Onze tarieven beginnen bij 35 EUR per dag, zonder verrassingen achteraf. Verzekering, rovinieta en onbeperkte kilometers zitten altijd inbegrepen in de prijs.",
            "Omdat wij geen borg of creditcard vereisen, blijft autohuur bij ons toegankelijk voor iedere reiziger.",
          ],
        },
        {
          h2: "Waar u nog meer op bespaart",
          body: [
            "Ophalen op ons kantoor in Boekarest of op Otopeni Airport is altijd gratis, wat extra kosten scheelt ten opzichte van veel concurrenten.",
            "Doordat rovinieta en verzekering al inbegrepen zijn, hoeft u geen aparte kosten bij te betalen tijdens uw reis.",
          ],
        },
        {
          h2: "Kwaliteit tegen een lage prijs",
          body: [
            "Onze 28 auto's worden regelmatig onderhouden, zodat een lage prijs nooit ten koste gaat van veiligheid of comfort.",
            "Met 24/7 overdracht en WhatsApp-ondersteuning op +40738792499 blijft budgetvriendelijk huren ook praktisch en flexibel.",
          ],
        },
      ],
      faqs: [
        { q: "Wat is de goedkoopste huurprijs bij carentals.ro?", a: "Onze auto's zijn beschikbaar vanaf 35 EUR per dag, inclusief verzekering en rovinieta." },
        { q: "Zijn er verborgen kosten bij goedkope autohuur?", a: "Nee, alle belangrijke kosten zoals verzekering en rovinieta zitten al in de prijs." },
        { q: "Heb ik een creditcard nodig voor de goedkoopste tarieven?", a: "Nee, wij vragen nooit een creditcard of borg, ongeacht het tarief." },
        { q: "Is ophalen op de luchthaven inbegrepen in de lage prijs?", a: "Ja, ophalen op Otopeni Airport is altijd gratis." },
      ],
      keywords: "goedkope autohuur roemenie, budget auto huren roemenie, voordelige autoverhuur",
    },
    automatic: {
      slug: "automaat-huren-roemenie",
      title: "Automaat Huren Roemenië | carentals.ro",
      description: "Huur een automaat in Roemenië vanaf 35 EUR/dag, zonder borg. Verzekering en onbeperkte kilometers inbegrepen. Boek nu.",
      eyebrow: "Automatische transmissie",
      h1: "Automaat huren in Roemenië: comfortabel reizen",
      intro: "Liever geen handgeschakelde auto? Bij carentals.ro huurt u eenvoudig een auto met automatische transmissie, inclusief verzekering en onbeperkte kilometers, zonder borg.",
      perks,
      sections: [
        {
          h2: "Waarom kiezen voor een automaat",
          body: [
            "Een automaat is ideaal voor het drukke verkeer in Boekarest en voor lange ritten over de snelwegen en bergwegen van Roemenië. U rijdt comfortabeler zonder handmatig schakelen.",
            "Onze automaten zijn beschikbaar in verschillende formaten, van compacte modellen tot ruimere gezinsauto's.",
          ],
        },
        {
          h2: "Beschikbaarheid en reservering",
          body: [
            "Omdat automaten populair zijn, raden wij aan tijdig te reserveren, vooral tijdens het hoogseizoen. Neem contact op via WhatsApp op +40738792499 om beschikbaarheid te checken.",
            "Ophalen kan gratis op ons kantoor in Boekarest of op Otopeni Airport, net als bij onze andere auto's.",
          ],
        },
        {
          h2: "Zorgeloos rijden met automaat",
          body: [
            "Elke automaat wordt geleverd met RCA+CASCO-verzekering, rovinieta en onbeperkte kilometers, zonder extra kosten.",
            "Betaal zonder borg, via bankpas, contant in EUR of RON, of overschrijving.",
          ],
        },
      ],
      faqs: [
        { q: "Heeft carentals.ro auto's met automatische transmissie?", a: "Ja, wij bieden diverse modellen met automaat aan in ons wagenpark van 28 auto's." },
        { q: "Kost een automaat extra?", a: "De prijs is afhankelijk van het model, maar start net als andere auto's vanaf 35 EUR per dag." },
        { q: "Moet ik een automaat vooraf reserveren?", a: "Wij raden aan tijdig te reserveren om beschikbaarheid te garanderen, vooral in het hoogseizoen." },
        { q: "Is verzekering ook inbegrepen bij een automaat?", a: "Ja, RCA+CASCO en rovinieta zijn standaard inbegrepen bij alle auto's, ook automaten." },
      ],
      keywords: "automaat huren roemenie, automatische transmissie auto huren, auto met automaat boekarest",
    },
    "unlimited-km": {
      slug: "onbeperkte-kilometers-autohuur",
      title: "Autohuur Onbeperkte Kilometers Roemenië – carentals.ro",
      description: "Huur een auto in Roemenië met onbeperkte kilometers, zonder borg. Vanaf 35 EUR/dag, verzekering en rovinieta inbegrepen.",
      eyebrow: "Rijden zonder limiet",
      h1: "Autohuur met onbeperkte kilometers in Roemenië",
      intro: "Bij carentals.ro rijdt u zo veel als u wilt: alle huurauto's komen standaard met onbeperkte kilometers, zonder verrassingen achteraf op uw factuur.",
      perks,
      sections: [
        {
          h2: "Volledige vrijheid onderweg",
          body: [
            "Of u nu een dagtrip maakt naar de bergen of een lange rondreis door heel Roemenië plant, met onbeperkte kilometers hoeft u zich nooit zorgen te maken over extra kosten.",
            "Dit maakt onze auto's ideaal voor road trips zoals de Transfăgărășan, de kust van de Zwarte Zee of een tour door Transsylvanië.",
          ],
        },
        {
          h2: "Geen verborgen kilometertarieven",
          body: [
            "Sommige verhuurders rekenen extra per kilometer boven een bepaalde limiet. Bij carentals.ro is dit nooit het geval: de prijs die u ziet, is de prijs die u betaalt.",
            "Deze transparantie geldt voor al onze 28 auto's, ongeacht het model of de huurperiode.",
          ],
        },
        {
          h2: "Combineer met volledige verzekering",
          body: [
            "Onbeperkte kilometers worden gecombineerd met RCA+CASCO-verzekering en rovinieta, zodat u zonder zorgen elke afstand kunt afleggen.",
            "Bij vragen over uw geplande route staat ons team klaar via WhatsApp op +40738792499.",
          ],
        },
      ],
      faqs: [
        { q: "Zijn alle auto's inbegrepen met onbeperkte kilometers?", a: "Ja, elke huurauto bij carentals.ro heeft standaard onbeperkte kilometers." },
        { q: "Betaal ik extra voor lange ritten?", a: "Nee, er zijn geen extra kosten voor het aantal gereden kilometers." },
        { q: "Kan ik hiermee ook naar de Zwarte Zee rijden?", a: "Zeker, onbeperkte kilometers maken lange ritten naar de kust of de bergen zonder zorgen mogelijk." },
        { q: "Geldt dit ook voor de 7-zitters?", a: "Ja, onbeperkte kilometers gelden voor het volledige wagenpark, inclusief 7-zitters." },
      ],
      keywords: "onbeperkte kilometers autohuur, auto huren zonder km limiet roemenie",
    },
    "one-way": {
      slug: "one-way-autohuur-roemenie",
      title: "One-Way Autohuur Roemenië – carentals.ro",
      description: "One-way autohuur in Roemenië: haal op in Boekarest, lever in op een andere locatie. Offerte op aanvraag via WhatsApp.",
      eyebrow: "Flexibel op en afleveren",
      h1: "One-way autohuur: ophalen en afleveren op verschillende plekken",
      intro: "Wilt u uw auto ophalen in Boekarest en elders inleveren? Carentals.ro biedt one-way verhuur op aanvraag, met een duidelijke offerte vooraf.",
      perks,
      sections: [
        {
          h2: "Flexibiliteit voor uw route",
          body: [
            "One-way verhuur is ideaal als u een rondreis plant die niet in Boekarest eindigt, bijvoorbeeld richting Brasov, Cluj-Napoca of de kust van de Zwarte Zee.",
            "Zo bespaart u tijd en hoeft u niet terug te rijden naar uw startpunt om de auto in te leveren.",
          ],
        },
        {
          h2: "Offerte op maat",
          body: [
            "Omdat de kosten van one-way verhuur afhangen van de afstand en de inleverlocatie, vragen wij u dit vooraf via WhatsApp op +40738792499 te bespreken.",
            "Wij bevestigen snel de mogelijkheden en een transparante prijs, zonder verborgen kosten achteraf.",
          ],
        },
        {
          h2: "Dezelfde voorwaarden, ongeacht de route",
          body: [
            "Ook bij one-way verhuur geniet u van RCA+CASCO-verzekering, rovinieta en onbeperkte kilometers.",
            "Betaal zonder borg, via bankpas, contant in EUR of RON, of overschrijving.",
          ],
        },
      ],
      faqs: [
        { q: "Is one-way verhuur mogelijk bij carentals.ro?", a: "Ja, dit kan op aanvraag geregeld worden, met een offerte op maat." },
        { q: "Wat kost een one-way huur?", a: "De kosten hangen af van de afstand tussen ophaal- en inleverlocatie. Vraag een gratis offerte via WhatsApp." },
        { q: "Kan ik overal in Roemenië de auto inleveren?", a: "In principe wel, dit bespreken wij graag samen met u via WhatsApp op +40738792499." },
        { q: "Blijft de verzekering geldig bij one-way huur?", a: "Ja, RCA+CASCO en rovinieta blijven altijd inbegrepen, ongeacht de route." },
      ],
      keywords: "one-way autohuur roemenie, auto huren en elders inleveren, one way car rental roemenie",
    },
    "seven-seater": {
      slug: "7-zits-auto-huren-roemenie",
      title: "7-Zits Auto Huren Roemenië – carentals.ro",
      description: "Huur een 7-zits auto of minivan in Roemenië vanaf 35 EUR/dag, zonder borg. Ideaal voor gezinnen en groepen.",
      eyebrow: "Ruimte voor het hele gezelschap",
      h1: "7-zits auto huren: comfortabel reizen met de hele groep",
      intro: "Reist u met een grote familie of groep vrienden? Bij carentals.ro huurt u eenvoudig een ruime 7-zitter, inclusief verzekering en onbeperkte kilometers, zonder borg.",
      perks,
      sections: [
        {
          h2: "Ideaal voor gezinnen en groepen",
          body: [
            "Onze 7-zitters bieden voldoende ruimte voor bagage én passagiers, perfect voor een familievakantie of een reis met vrienden door Roemenië.",
            "Deze auto's zijn even comfortabel voor korte stadsritten in Boekarest als voor lange tochten naar de bergen of de kust.",
          ],
        },
        {
          h2: "Reserveer op tijd",
          body: [
            "Omdat 7-zitters minder talrijk zijn in ons wagenpark van 28 auto's, raden wij aan om ruim vooraf te reserveren, vooral in het hoogseizoen.",
            "Neem contact op via WhatsApp op +40738792499 om de beschikbaarheid voor uw reisdatum te controleren.",
          ],
        },
        {
          h2: "Alles inbegrepen, ook voor grote groepen",
          body: [
            "Ook onze 7-zitters bevatten standaard RCA+CASCO-verzekering, rovinieta en onbeperkte kilometers, zonder extra kosten.",
            "Betaal zonder borg, via bankpas, contant in EUR of RON, of overschrijving.",
          ],
        },
      ],
      faqs: [
        { q: "Heeft carentals.ro 7-zits auto's beschikbaar?", a: "Ja, ons wagenpark van 28 auto's bevat ook ruime 7-zitters, geschikt voor gezinnen en groepen." },
        { q: "Kost een 7-zitter meer dan een gewone auto?", a: "De prijs varieert per model, maar begint net als de rest vanaf 35 EUR per dag." },
        { q: "Moet ik een 7-zitter ver vooraf reserveren?", a: "We raden aan tijdig te boeken, vooral in het hoogseizoen, om beschikbaarheid te garanderen." },
        { q: "Is er ook een borg nodig voor 7-zitters?", a: "Nee, ook voor 7-zitters vragen wij geen borg of creditcard." },
      ],
      keywords: "7 zits auto huren roemenie, minivan huren roemenie, gezinsauto huren boekarest",
    },
    "guide-transfagarasan": {
      slug: "reisgids-transfagarasan",
      title: "Reisgids Transfăgărășan | Autohuur carentals.ro",
      description: "Plan uw roadtrip over de Transfăgărășan met een huurauto van carentals.ro. Verzekering en onbeperkte kilometers inbegrepen.",
      eyebrow: "Roadtrip door de Karpaten",
      h1: "De Transfăgărășan verkennen met uw eigen huurauto",
      intro: "De Transfăgărășan is een van de meest spectaculaire bergwegen van Europa. Met een huurauto van carentals.ro rijdt u deze route zorgeloos, met volledige verzekering en onbeperkte kilometers.",
      perks: guidePerks,
      sections: [
        {
          h2: "Wat u moet weten over de route",
          body: [
            "De Transfăgărășan slingert door de Zuidelijke Karpaten en biedt adembenemende uitzichten, maar vraagt ook om een betrouwbare auto en oplettend rijden.",
            "De weg is doorgaans open van juni tot oktober; buiten dit seizoen kan sneeuw de doorgang blokkeren, dus check dit vooraf.",
          ],
        },
        {
          h2: "De juiste auto voor de bergen",
          body: [
            "Kies een auto die comfortabel is bij bochten en hoogteverschillen; ons wagenpark biedt hiervoor geschikte modellen, inclusief automaat.",
            "Onbeperkte kilometers en volledige verzekering geven u de vrijheid om onderweg te stoppen bij uitzichtpunten zoals het Bâlea-meer.",
          ],
        },
        {
          h2: "Praktische tips voor onderweg",
          body: [
            "Start vroeg op de dag om drukte te vermijden en tank vooraf vol, want brandstofstations zijn schaars op de route zelf.",
            "Bij vragen over de route of de staat van de weg staat ons team klaar via WhatsApp op +40738792499.",
          ],
        },
      ],
      faqs: [
        { q: "Wanneer is de Transfăgărășan open?", a: "Doorgaans van juni tot oktober, afhankelijk van de sneeuwval in de bergen." },
        { q: "Is mijn huurauto geschikt voor deze route?", a: "Onze auto's zijn geschikt voor de Transfăgărășan; wij adviseren u graag over het beste model." },
        { q: "Is de verzekering geldig op bergwegen?", a: "Ja, RCA+CASCO dekt uw volledige reis, ook op bergroutes zoals deze." },
        { q: "Kan ik onderweg tanken?", a: "Tankstations zijn schaars op de route, dus tank vooraf vol in Sibiu of Curtea de Argeș." },
      ],
      keywords: "transfagarasan roadtrip, autohuur transfagarasan, bergroute roemenie auto huren",
    },
    "guide-transylvania": {
      slug: "reisgids-transsylvanie",
      title: "Reisgids Transsylvanië | Autohuur carentals.ro",
      description: "Ontdek Transsylvanië met een huurauto van carentals.ro. Onbeperkte kilometers, verzekering inbegrepen, geen borg nodig.",
      eyebrow: "Rondreis door Transsylvanië",
      h1: "Transsylvanië verkennen met een huurauto",
      intro: "Kastelen, middeleeuwse steden en groene heuvels: Transsylvanië is ideaal om te verkennen met een eigen huurauto van carentals.ro, inclusief verzekering en onbeperkte kilometers.",
      perks: guidePerks,
      sections: [
        {
          h2: "Hoogtepunten van de regio",
          body: [
            "Steden als Brasov, Sibiu en Cluj-Napoca combineren rijke geschiedenis met een levendige sfeer, terwijl kastelen als Bran en Peleș tot de verbeelding spreken.",
            "Met een auto reist u vlot tussen deze bestemmingen, zonder afhankelijk te zijn van openbaar vervoer of georganiseerde tours.",
          ],
        },
        {
          h2: "De juiste route plannen",
          body: [
            "Een rondreis van vijf tot zeven dagen door Transsylvanië, vertrekkend vanuit Boekarest, geeft u voldoende tijd om de belangrijkste steden en natuurgebieden te bezoeken.",
            "Dankzij onbeperkte kilometers kunt u zonder zorgen omwegen maken naar minder bekende dorpjes en uitzichtpunten.",
          ],
        },
        {
          h2: "Praktisch geregeld",
          body: [
            "U kunt de auto ophalen in Boekarest en, indien gewenst, elders inleveren via onze one-way service op aanvraag.",
            "Voor vragen over uw route staat ons team klaar via WhatsApp op +40738792499, ook tijdens uw reis.",
          ],
        },
      ],
      faqs: [
        { q: "Hoeveel dagen heb ik nodig voor Transsylvanië?", a: "Reken op minimaal vijf tot zeven dagen om de belangrijkste steden en kastelen te bezoeken." },
        { q: "Kan ik de auto in een andere stad inleveren?", a: "Ja, via onze one-way service op aanvraag, met een offerte op maat." },
        { q: "Zijn de wegen in Transsylvanië goed begaanbaar?", a: "Over het algemeen wel, al zijn sommige bergwegen bochtig en vragen om voorzichtig rijden." },
        { q: "Is verzekering inbegrepen tijdens de hele rondreis?", a: "Ja, RCA+CASCO en rovinieta gelden voor de volledige huurperiode, waar u ook rijdt." },
      ],
      keywords: "transsylvanie roadtrip, autohuur transsylvanie, rondreis roemenie auto",
    },
    "guide-black-sea": {
      slug: "reisgids-zwarte-zee",
      title: "Reisgids Zwarte Zee | Autohuur carentals.ro",
      description: "Rijd naar de Zwarte Zee met een huurauto van carentals.ro. Onbeperkte kilometers en verzekering inbegrepen, geen borg.",
      eyebrow: "Roadtrip naar de kust",
      h1: "Op weg naar de Zwarte Zee met uw huurauto",
      intro: "De kust van de Zwarte Zee, met bestemmingen als Mamaia en Vama Veche, is eenvoudig te bereiken met een huurauto van carentals.ro, inclusief onbeperkte kilometers.",
      perks: guidePerks,
      sections: [
        {
          h2: "Van Boekarest naar de kust",
          body: [
            "De rit van Boekarest naar Constanța en de omliggende badplaatsen duurt doorgaans twee tot drie uur, ideaal voor een dagtrip of langer verblijf.",
            "Met onbeperkte kilometers kunt u onderweg stoppen bij verschillende strandplaatsen zonder u zorgen te maken over extra kosten.",
          ],
        },
        {
          h2: "Populaire bestemmingen aan zee",
          body: [
            "Mamaia is bekend om zijn brede stranden en levendige sfeer, terwijl Vama Veche een rustiger, alternatiever karakter heeft.",
            "Onze auto's zijn comfortabel voor de snelweg naar de kust en bieden voldoende ruimte voor strandbenodigdheden en bagage.",
          ],
        },
        {
          h2: "Praktische reistips",
          body: [
            "Vermijd drukte door in het weekend vroeg te vertrekken, vooral in de zomermaanden wanneer de snelweg naar Constanța druk kan zijn.",
            "Bij vragen over uw route naar de kust helpt ons team u graag via WhatsApp op +40738792499.",
          ],
        },
      ],
      faqs: [
        { q: "Hoe lang duurt de rit van Boekarest naar de Zwarte Zee?", a: "Gemiddeld twee tot drie uur, afhankelijk van de exacte bestemming en het verkeer." },
        { q: "Welke badplaats is het populairst?", a: "Mamaia is de bekendste en drukste badplaats, terwijl Vama Veche rustiger en alternatiever is." },
        { q: "Is de snelweg naar Constanța druk?", a: "In de zomer kan het druk zijn, vooral in het weekend, dus vroeg vertrekken wordt aangeraden." },
        { q: "Kan ik de auto ook aan de kust inleveren?", a: "Ja, dit kan via onze one-way service op aanvraag." },
      ],
      keywords: "zwarte zee roadtrip, autohuur constanta mamaia, auto huren naar de kust roemenie",
    },
    "rules-rovinieta": {
      slug: "rovinieta-uitleg",
      title: "Rovinieta Roemenië Uitgelegd – carentals.ro",
      description: "Alles over de rovinieta (wegenvignet) in Roemenië. Bij carentals.ro is deze altijd inbegrepen in de huurprijs.",
      eyebrow: "Wegenvignet Roemenië",
      h1: "Rovinieta: het wegenvignet van Roemenië uitgelegd",
      intro: "In Roemenië heeft u een rovinieta nodig om op de meeste wegen te rijden. Bij carentals.ro is dit wegenvignet altijd inbegrepen, zodat u zich hier geen zorgen over hoeft te maken.",
      perks: rulesPerks,
      sections: [
        {
          h2: "Wat is de rovinieta precies",
          body: [
            "De rovinieta is een elektronisch wegenvignet dat verplicht is voor het gebruik van nationale wegen en snelwegen in Roemenië. Zonder geldige rovinieta riskeert u een boete.",
            "Normaal moet u dit zelf online of bij een tankstation aanschaffen, maar bij carentals.ro zit dit altijd al bij de huurprijs inbegrepen.",
          ],
        },
        {
          h2: "Waarom dit voor u wordt geregeld",
          body: [
            "Wij willen dat u zonder administratieve rompslomp op reis kunt, dus regelen wij de rovinieta automatisch voor elke huurauto die u bij ons huurt.",
            "Dit scheelt u tijd en voorkomt het risico op boetes door een vergeten of verlopen vignet.",
          ],
        },
        {
          h2: "Rijden zonder zorgen",
          body: [
            "Zodra u de auto ophaalt, bent u volledig in orde met de rovinieta-verplichting, waar u ook in Roemenië naartoe rijdt.",
            "Heeft u vragen over specifieke wegen of tolheffingen? Ons team helpt u graag via WhatsApp op +40738792499.",
          ],
        },
      ],
      faqs: [
        { q: "Wat is een rovinieta?", a: "Een elektronisch wegenvignet dat verplicht is voor gebruik van de meeste wegen in Roemenië." },
        { q: "Moet ik zelf een rovinieta kopen?", a: "Nee, bij carentals.ro is de rovinieta altijd inbegrepen in de huurprijs." },
        { q: "Wat gebeurt er als ik geen geldige rovinieta heb?", a: "U riskeert een boete, maar dit is niet van toepassing bij onze huurauto's, aangezien deze altijd geregeld is." },
        { q: "Geldt de rovinieta voor heel Roemenië?", a: "Ja, de rovinieta geldt voor de meeste nationale wegen en snelwegen in het land." },
      ],
      keywords: "rovinieta roemenie, wegenvignet roemenie, autohuur rovinieta inbegrepen",
    },
    "rules-winter-tires": {
      slug: "winterbanden-roemenie",
      title: "Winterbanden Roemenië: Regels – carentals.ro",
      description: "Alles over winterbanden in Roemenië. Onze auto's zijn uitgerust voor de winter, inclusief verzekering en rovinieta.",
      eyebrow: "Veilig rijden in de winter",
      h1: "Winterbanden in Roemenië: wat u moet weten",
      intro: "Roemenië kan strenge winters hebben, vooral in de bergen. Bij carentals.ro zorgen wij dat onze auto's passend zijn uitgerust, zodat u veilig kunt reizen.",
      perks: rulesPerks,
      sections: [
        {
          h2: "Wanneer zijn winterbanden verplicht",
          body: [
            "In Roemenië geldt de regel dat auto's bij winterse omstandigheden zoals sneeuw, ijzel of natte wegen bij lage temperaturen uitgerust moeten zijn met winterbanden of sneeuwkettingen.",
            "Deze verplichting geldt vooral van november tot maart, met name in bergachtige gebieden zoals de Karpaten.",
          ],
        },
        {
          h2: "Hoe carentals.ro dit regelt",
          body: [
            "Tijdens de wintermaanden voorzien wij onze auto's van geschikte banden, zodat u zonder zorgen op pad kunt, ook op bergroutes.",
            "Dit is inbegrepen in de huurprijs; u hoeft hier zelf niets voor te regelen of bij te betalen.",
          ],
        },
        {
          h2: "Veilig rijden in winterse omstandigheden",
          body: [
            "Rijd rustig en houd extra afstand bij sneeuw of ijzel, vooral op bergwegen. Controleer vooraf de weersvoorspelling voor uw route.",
            "Heeft u vragen over de rijomstandigheden tijdens uw reis? Neem contact op via WhatsApp op +40738792499.",
          ],
        },
      ],
      faqs: [
        { q: "Zijn winterbanden verplicht in Roemenië?", a: "Ja, bij winterse omstandigheden zijn winterbanden of sneeuwkettingen verplicht, vooral van november tot maart." },
        { q: "Regelt carentals.ro dit voor mij?", a: "Ja, onze auto's worden tijdens de wintermaanden voorzien van geschikte banden, inbegrepen in de prijs." },
        { q: "Is het veilig om in de winter naar de Karpaten te rijden?", a: "Met de juiste banden en voorzichtig rijgedrag is dit goed mogelijk, al raden wij aan de weersomstandigheden te checken." },
        { q: "Moet ik extra betalen voor winterbanden?", a: "Nee, dit zit inbegrepen in de huurprijs, zonder extra kosten." },
      ],
      keywords: "winterbanden roemenie, sneeuwkettingen roemenie regels, auto huren winter roemenie",
    },
    "rules-speed-cameras": {
      slug: "snelheidscontroles-roemenie",
      title: "Snelheidscontroles Roemenië: Regels – carentals.ro",
      description: "Wat u moet weten over snelheidscontroles en boetes in Roemenië. Rijd veilig met een huurauto van carentals.ro.",
      eyebrow: "Verkeersregels Roemenië",
      h1: "Snelheidscontroles in Roemenië: wat u moet weten",
      intro: "Roemenië kent strikte snelheidscontroles, zowel met vaste als mobiele camera's. Rijd veilig en voorkom boetes met deze praktische informatie van carentals.ro.",
      perks: rulesPerks,
      sections: [
        {
          h2: "Snelheidslimieten in Roemenië",
          body: [
            "In bebouwde kom geldt doorgaans 50 km/u, buiten de bebouwde kom 90 km/u, en op snelwegen tot 130 km/u, tenzij anders aangegeven met verkeersborden.",
            "Deze limieten worden streng gecontroleerd, zowel door de politie als met vaste en mobiele snelheidscamera's langs de weg.",
          ],
        },
        {
          h2: "Hoe controles werken",
          body: [
            "Naast vaste camera's gebruikt de Roemeense politie regelmatig mobiele radarapparatuur, vaak langs snelwegen en op doorgaande wegen tussen steden.",
            "Boetes kunnen direct ter plaatse worden opgelegd en variëren afhankelijk van de overschrijding en de locatie.",
          ],
        },
        {
          h2: "Veilig en zonder boetes reizen",
          body: [
            "Houd u aan de aangegeven snelheidslimieten, vooral bij het binnenrijden van dorpen en steden, waar de limiet vaak plotseling verlaagt.",
            "Bij twijfel over verkeersborden of regels kunt u altijd contact opnemen met ons team via WhatsApp op +40738792499.",
          ],
        },
      ],
      faqs: [
        { q: "Wat is de maximumsnelheid in Roemenië?", a: "Doorgaans 50 km/u in de bebouwde kom, 90 km/u daarbuiten, en tot 130 km/u op snelwegen." },
        { q: "Zijn er veel snelheidscamera's in Roemenië?", a: "Ja, zowel vaste als mobiele camera's worden veelvuldig ingezet, vooral op snelwegen en doorgaande wegen." },
        { q: "Wat gebeurt er bij een snelheidsovertreding?", a: "U kunt een boete krijgen, die kan variëren afhankelijk van de mate van overschrijding." },
        { q: "Wie is verantwoordelijk voor boetes tijdens de huurperiode?", a: "De huurder is verantwoordelijk voor eventuele verkeersboetes opgelopen tijdens de huurperiode." },
      ],
      keywords: "snelheidscontrole roemenie, verkeersboete roemenie, maximumsnelheid roemenie",
    },
    "airport-pickup": {
      slug: "afhalen-otopeni-stappenplan",
      title: "Auto Afhalen Otopeni: Stappenplan – carentals.ro",
      description: "Stap voor stap uitgelegd hoe u uw huurauto afhaalt op Otopeni Airport bij carentals.ro. Gratis, snel en zonder borg.",
      eyebrow: "Praktische gids Otopeni",
      h1: "Zo haalt u uw huurauto op bij Otopeni Airport",
      intro: "Een auto ophalen op Henri Coandă Airport is bij carentals.ro eenvoudig geregeld. Volg dit stappenplan voor een vlotte start van uw reis, zonder borg en zonder wachttijd.",
      perks: airportPerks,
      sections: [
        {
          h2: "Stap 1: uw vlucht doorgeven",
          body: [
            "Stuur uw vluchtnummer en geschatte aankomsttijd via WhatsApp naar +40738792499, het liefst een dag voor vertrek. Zo weten wij precies wanneer u aankomt.",
            "Bij vertraging past ons team de ophaaltijd automatisch aan, zodat u nooit hoeft te wachten of extra kosten maakt.",
          ],
        },
        {
          h2: "Stap 2: aankomst en ontmoeting",
          body: [
            "Na het ophalen van uw bagage en het passeren van de douane, brengen wij u snel naar uw huurauto, die klaarstaat op de luchthaven.",
            "Dit gebeurt gratis, zonder extra luchthaventoeslag, en zonder dat u een borg of creditcard hoeft te tonen.",
          ],
        },
        {
          h2: "Stap 3: documenten en vertrek",
          body: [
            "U ondertekent het huurcontract, ontvangt de sleutels en een korte uitleg over de auto, inclusief de al inbegrepen verzekering en rovinieta.",
            "Daarna kunt u direct vertrekken richting Boekarest of verder het land in, zonder oponthoud aan een balie.",
          ],
        },
      ],
      faqs: [
        { q: "Hoe geef ik mijn vluchtgegevens door?", a: "Via WhatsApp op +40738792499, het liefst een dag voor uw aankomst op Otopeni." },
        { q: "Moet ik betalen voor ophalen op de luchthaven?", a: "Nee, ophalen op Otopeni Airport is altijd gratis." },
        { q: "Wat als mijn vlucht vertraagd is?", a: "Wij passen de ophaaltijd automatisch aan zodra u ons uw vluchtgegevens heeft doorgegeven." },
        { q: "Heb ik documenten nodig bij het ophalen?", a: "Ja, uw rijbewijs en identiteitsbewijs of paspoort zijn voldoende, een creditcard is niet nodig." },
      ],
      keywords: "auto afhalen otopeni, huurauto ophalen boekarest airport, stappenplan autohuur otopeni",
    },
  },
};
